import * as types from "./../types";

const state = {
  modalStep: 1,
  isModalOpen: false
};

const getters = {
  [types.phone.getters.IS_MODAL_OPEN]: state => {
    return state.isModalOpen;
  },
  [types.phone.getters.MODAL_STEP]: state => {
    return state.modalStep;
  }
};

const mutations = {
  [types.phone.mutations.MUTATE_STEP]: (state, payload) => {
    state.modalStep = payload;
  },
  [types.phone.mutations.MUTATE_MODAL]: (state, payload) => {
    state.isModalOpen = payload;
  }
};

const actions = {
  [types.phone.actions.SET_STEP]: ({ commit }, payload) => {
    commit(types.phone.mutations.MUTATE_STEP, payload);
  },
  [types.phone.actions.SET_MODAL]: ({ commit }, payload) => {
    commit(types.phone.mutations.MUTATE_MODAL, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
